import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";

const tagsAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name)
});

const initialState = {
  tags: tagsAdapter.getInitialState(),

  editor: {
    show: false,
    mode: null,
    deleteConfirmationModal: false
  }
};

export const tagsSlice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.tag = action.payload.tag;
      state.editor.deleteConfirmationModal = false;
    },

    hideEditor: state => {
      state.editor.show = false;
      state.editor.deleteConfirmationModal = false;
    },

    showHideDeleteConfirmationModal: (state, action) => {
      state.editor.deleteConfirmationModal = action.payload;
    },

    updateTags: (state, action) => {
      tagsAdapter.setMany(state.tags, action.payload.u || []);
      tagsAdapter.removeMany(state.tags, action.payload.d || []);
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      tagsAdapter.setMany(state.tags, action.payload.tags);
    });
  }
});

export const {
  showEditor: rxShowTagEditor,
  hideEditor: rxHideTagEditor,
  updateTags: rxUpdateTags,
  showHideDeleteConfirmationModal: rxShowHideDeleteConfirmationModal
} = tagsSlice.actions;

export const {selectAll: selectAllTags} = tagsAdapter.getSelectors(state => state.tags.tags);

export const editorConfigSelector = state => state.tags.editor;

export default tagsSlice.reducer;
